(function () {
  "use strict";

  function btoa(str) {
    var buffer;

    if (str instanceof Buffer) {
      buffer = str;
    } else {
      buffer = Buffer.from(str.toString(), 'binary');
    }

    return buffer.toString('base64');
  }

  module.exports = btoa;
}());



//////////////////
// WEBPACK FOOTER
// ./~/btoa/index.js
// module id = 887
// module chunks = 0